export const BACCOUNTS = "BACCOUNTS";
export const BUSY_BACCOUNT = "BUSY_BACCOUNT";
export const BACCOUNT_COUNT = "BACCOUNT_COUNT";
export const SELECTED_BACCOUNT = "SELECTED_BACCOUNT";

export const PRINT_CHECKS = "PRINT_CHECKS";
export const PRINT_CHECKS_COUNT = "PRINT_CHECKS_COUNT";
